export function loadLocaleMessages(locale) {switch (locale) {
case 'tl-PH':
            return import('./tl-PH.json')
case 'en-US':
            return import('./en-US.json')
 default:
            return import('./en-US.json')}}